import { defineStore, acceptHMRUpdate } from 'pinia';

export const useAppRunningStore = defineStore('AppRunning', () => {
  const isRunning = ref(false);
  const nuxtApp = useNuxtApp();
  const start = async () => {
    if (!nuxtApp.$db.isOpen()) {
      await nuxtApp.$db.open();
    }
    isRunning.value = true;
  };

  const forceStop = () => {
    window.location.reload();
  };

  return {
    forceStop,
    start,
    isRunning,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppRunningStore, import.meta.hot));
}
